import { useState } from 'react';
import { FieldArrayWithId, UseFormReturn, useWatch } from 'react-hook-form';
import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { PropertyBaseKey } from '../types';
import { useOpenEventPanel } from '../../../use-open-event-panel';

export function usePropertyFieldsetState(props: {
    form: UseFormReturn<EventPanelFormType>;
    index: number;
    field: FieldArrayWithId<EventPanelFormType, PropertyBaseKey, 'rhfKey'>;
    baseKey: PropertyBaseKey;
    allowMembersControl?: boolean;
    displayAsCards?: boolean;
    eventPanelOptions: EventPanelOptions;
    eventId?: number | null;
}) {
    const { form: eventForm, index, baseKey, displayAsCards, eventId } = props;
    const [showExtraFields, setShowExtraFields] = useState(false);

    const openEventPanel = useOpenEventPanel();

    const isPersisted = useWatch({
        control: eventForm.control,
        name: `${props.baseKey}.${index}.isPersisted`,
    });

    const propertyId = useWatch({
        control: eventForm.control,
        name: `${baseKey}.${index}.id`,
        // disable useWatch in new event form. 'propertyId' is always undefined in new event panel.
        // if we watch 'propertyId' in new event panel, there will be 'Can't perform a React state update on an unmounted component' warning,
        // since 'useWatch' is called after 'setValue' in 'onReplaceVehicles'
        disabled: !eventId,
    });

    function onOpenMergedEvent() {
        const eventId = props.field.eventInfo?.id;
        if (eventId) {
            openEventPanel({
                eventId: props.field.eventInfo?.id ?? undefined,
            });
        }
    }

    const showDexFields = !displayAsCards || !isPersisted;

    return {
        setShowExtraFields,
        onOpenMergedEvent,
        showExtraFields,
        isPersisted,
        showDexFields,
        propertyId,
    };
}
